import { ExclamationCircleOutlined } from '@ant-design/icons'
import { Tag } from 'antd'
import { CSSProperties, FC } from 'react'
import { formatUtcOffset } from '../utils/dates'

interface TimeZoneOffsetTagProps {
  timeZone: string
  style?: CSSProperties
}

export const TimeZoneOffsetTag: FC<TimeZoneOffsetTagProps> = ({ timeZone, style }) => {
  return (
    <Tag icon={<ExclamationCircleOutlined />} color='default' style={{ fontWeight: 'bold', ...style }}>
      UTC{formatUtcOffset(timeZone)}
    </Tag>
  )
}
